import { render } from "./editModel.vue?vue&type=template&id=7a89a7fd"
import script from "./editModel.vue?vue&type=script&lang=js"
export * from "./editModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__